// services/craApi.js
import { apiSlice } from "services/apiSlice";

export const craApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // 🔹 Récupérer tous les CRA d'un collaborateur
    getCRAByCollaborator: builder.query({
      query: (collaboratorId) => `cra/collaborator/${collaboratorId}`,
      providesTags: ["CRA"],
    }),

    // Récupérer les CRA d'un utilisateur par mois et année
    getCRA: builder.query({
      query: ({ userId, month, year }) =>
        `cra/${userId}?month=${month}&year=${year}`,
      providesTags: ["CRA"],
    }),

    // Récupérer un CRA par ID
    getCRAById: builder.query({
      query: (craId) => `cra/${craId}`,
      providesTags: ["CRA"],
    }),
    // 🔹 Récupérer les CRA d'un validateur avec status pending_validation
    getCRAByValidateurPending: builder.query({
      query: (validateurId) => `cra/validateur/${validateurId}/pending`,
      providesTags: ["CRA"],
    }),

    // Créer un nouveau CRA
    createCRA: builder.mutation({
      query: (formData) => ({
        url: "cra",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["CRA"],
    }),

    // Mettre à jour un CRA existant
    updateCRA: builder.mutation({
      query: ({ craId, formData }) => ({
        url: `cra/${craId}`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["CRA"],
    }),

    // Envoyer CRA au validateur
    sendToValidator: builder.mutation({
      query: ({ craId, message }) => ({
        url: `/cra/${craId}/send-to-validator`,
        method: "POST",
        body: { message },
      }),
    }),

    // Valider le CRA
    validateCRA: builder.mutation({
      query: (craId) => ({
        url: `/cra/${craId}/validate`,
        method: "POST",
      }),
      invalidatesTags: ["CRA"],
    }),

    // Refuser le CRA
    refuseCRA: builder.mutation({
      query: ({ craId, reason }) => ({
        url: `cra/${craId}/refuse`,
        method: "POST",
        body: { reason },
      }),
      invalidatesTags: ["CRA"],
    }),
  }),
  overrideExisting: false,
});

// Export des hooks
export const {
  useGetCRAQuery,
  useGetCRAByIdQuery,
  useGetCRAByCollaboratorQuery, // 🔹 nouveau hook
  useCreateCRAMutation,
  useUpdateCRAMutation,
  useSendToValidatorMutation,
  useGetCRAByValidateurPendingQuery,
  useValidateCRAMutation,
  useRefuseCRAMutation,
} = craApi;
